import React, { useState } from "react";
import { useAppSelector } from "../../store/hooks";
import ModalNew from "./ModalNew";
import EmailVerifyModal from "./EmailVerifyModal";
import img from "../../constant";

interface ModalProps {
  open: boolean;
  link: string;
  btnText: string;
  onClose?: () => void;
}

const ModalSuccess: React.FC<ModalProps> = ({
  open,
  link,
  btnText,
  onClose,
}) => {
  const message = useAppSelector(({ message }) => message.message);
  const title = useAppSelector(({ message }) => message.title);
  const status = useAppSelector(({ message }) => message.status);
  const [open1, setOpen] = useState(false);
  console.log(open1);

  const handleClose = () => {
    setOpen(false);
    onClose?.();
  };

  return (
    <ModalNew isOpen={open} onClose={handleClose} title="">
      <EmailVerifyModal
        title={title}
        message={message}
        image={status === "success" ? img.emailVerify : img.error}
        btnText={btnText}
        link={link}
        onClose={onClose}
      />
    </ModalNew>
  );
};

export default ModalSuccess;
